import { render, staticRenderFns } from "./MainLedgerPrintCard5.vue?vue&type=template&id=4573c3c7&scoped=true"
import script from "./MainLedgerPrintCard5.vue?vue&type=script&lang=js"
export * from "./MainLedgerPrintCard5.vue?vue&type=script&lang=js"
import style0 from "./MainLedgerPrintCard5.vue?vue&type=style&index=0&id=4573c3c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4573c3c7",
  null
  
)

export default component.exports